export interface ReasonFields {
	[reason: string]: string;
}

export enum Status {
	removed = 'removed',
	beforeIntroduction = 'before-introduction',
	beforeValidity = 'before-validity',
	afterValidity = 'after-validity',
	danger = 'danger',
	warning = 'warning',
	ok = 'ok',
}

export default class ActualPackStatus {
	value: Status;

	reasonFields: ReasonFields;

	constructor(value: Status, reasonFields: ReasonFields) {
		this.value = value;
		this.reasonFields = reasonFields;
	}

	get isRemoved(): boolean {
		return this.value === Status.removed || this.value === Status.beforeIntroduction;
	}
}
